import { animate, createTimeline } from 'animejs';

export function toggleMenu() {
  const hamburger = document.querySelector('#hamburger');
  const mainMenu = document.querySelector('#main-menu');
  if (window.matchMedia("(max-width: 1024px)").matches) {
    const tlOpen = createTimeline({
      defaults: {
        ease: 'easeInOutSine',
      },
      autoplay: false,
    })
      .add(mainMenu, {
        height: ['0vh', '100vh'],
        duration: 1, // Instant height expansion
      }, 10)
      .add(mainMenu, {
        opacity: [0, 1],
        duration: 300, // Fade in,
      }, 100);

    const tlClose = createTimeline({
      defaults: {
        ease: 'easeInOutSine',
      },
      autoplay: false,
    })
      .add(mainMenu, {
        opacity: [1, 0],
        duration: 300, // Fade out,
      })
      .add(mainMenu, {
        height: ['100vh', '0vh'],
        duration: 1, // Instant height reduction
        onComplete: () => {
          mainMenu.classList.remove('active');
        }
      }, 300);

    if (hamburger != null) {

      hamburger.addEventListener('click', () => {
        document.body.classList.toggle('open');
        hamburger.classList.toggle('open');

        if (!mainMenu.classList.contains('active')) {
          mainMenu.classList.add('active');
          tlClose.pause(); // Pause closing animation if it was playing
          tlOpen.restart(); // Restart and play the opening animation
        } else {
          tlOpen.pause(); // Pause opening animation if it was playing
          tlClose.restart(); // Restart and play the closing animation
        }
      });
    }
  } else {
    mainMenu.style.height = 'auto';
  }
}
